import React, { useEffect, useRef } from 'react';
import _ from 'lodash'; // ✅ Add this line
import Span from '@jumbo/shared/Span/Span'; // ✅ Add this line

const SignatureCanvas = ({
  signatureData,
  height = 300,
  width = 300,
  margin_x = 10,
  margin_y = 10,
  caption = null
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !signatureData || signatureData.length === 0) return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 2;

    const points = _.flatten(_.map(signatureData, (p1) => p1.points));
    if (points.length === 0) return;

    const x_s = _.map(points, 'x');
    const y_s = _.map(points, 'y');
    const min_x = _.min(x_s), max_x = _.max(x_s);
    const min_y = _.min(y_s), max_y = _.max(y_s);
    const scale_factor_x = _.round(height / (max_x - min_x + 2 * margin_x), 1);
    const scale_factor_y = _.round(height / (max_y - min_y + 2 * margin_y), 1);
    const scale_factor = _.min([scale_factor_x, scale_factor_y]);

    _.each(signatureData, (sd) => {
      const currPoints = _.map(sd.points, (p1) => ({
        x: _.round(margin_x + (p1.x - min_x) * scale_factor, 1),
        y: _.round(margin_y + (p1.y - min_y) * scale_factor, 1)
      }));

      if (currPoints.length === 0) return;

      ctx.beginPath();
      ctx.moveTo(currPoints[0].x, currPoints[0].y);
      for (let i = 1; i < currPoints.length; i++) {
        ctx.lineTo(currPoints[i].x, currPoints[i].y);
      }
      ctx.stroke();
    });
  }, [signatureData, height, width, margin_x, margin_y]);

  return (
    <Span sx={{ position: 'relative' }}>
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{ border: '1px solid grey', borderRadius: 4 }}
      />
      {caption && <Span sx={{ position: 'absolute', bottom: 4, right: 4 }}>{caption}</Span>}
    </Span>
  );
};

export default SignatureCanvas;